import Gas from './index';

export default { path: '/home/gas', component: Gas };
